// Régimes de TVA proposés dans les selects (fiche client création/modification,
// création de société) — ajouter une valeur ici suffit, aucune migration
// nécessaire (Client.regimeTVA est un simple String? en base).
// Attention : seuls "RN" (Suivi TVA mensuel) et "RSI" (Suivi TVA RSI, CA12 du
// Suivi Bilan) alimentent un suivi TVA ; les autres régimes n'y figurent pas.
// "AST" (régime agricole) ajouté le 04/11/2026 (ticket de Reine Claude RIVIERE).
export const REGIME_TVA_OPTIONS = ["N/A", "Franchise", "RSI", "RN", "Mini réel", "AST"];
